<div [innerHTML]="'ConfirmUnpreparedContent' | translate: { preparationTime: timeWithStyle() }"></div>
